export const credentials = {
  sentryDNS:
    'https://7f7c10b472917d575ba2b732433642e7:a09fd776a343912d382767f17d368b5b@o423358.ingest.us.sentry.io/4510317338034176',
  googleClientId:
    '964261336247-vn35mrkcbtshlfpdoknmn9f5rgi452f7.apps.googleusercontent.com',
} as const
